<template>
  <div class="auth">
    <div class="banner"></div>
    <div class="help"></div>
    <div class="main">
      <div class="logo"></div>
      <div class="title-registration">Welcome to The BASEC Registration.</div>
      <div class="title-reg-fill">
        Please fill out the form below to get started.
      </div>

      <v-card flat="flat" class="card" :loading="loading">
        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-text-field
              v-model="username"
              label="Username"
              type="text"
              :rules="fieldRules"
              required
            ></v-text-field>

            <v-text-field
              v-model="email"
              label="Email"
              type="text"
              :rules="emailRule"
              required
              :disabled="emailEditDisabled"
            ></v-text-field>

            <v-text-field
              v-model="password"
              label="Password"
              type="password"
              :rules="passwordRules"
              required
            ></v-text-field>

            <v-text-field
              v-model="passwordConfirm"
              label="Confirm Password"
              type="password"
              :rules="passwordRules"
              required
            ></v-text-field>

            <v-text-field
              v-model="mobileNumber"
              label="Mobile Number"
              type="tel"
              v-mask="'(###) ###-####'"
              :rules="phoneRules"
              required
            ></v-text-field>

            <div class="step-verification">
              This number will be used for <b>2-Step Verification</b>
            </div>

            <div class="terms-check">
              <v-checkbox color="#2bb9aa" v-model="acceptPrivacy"></v-checkbox>
              <span
                >I accept the <a>Terms of Service</a> and
                <a>Privacy Policy.</a></span
              >
            </div>

            <v-alert v-if="!termsAgreed" type="error">
              Please check and agree to terms.
            </v-alert>

            <v-btn class="btn-submit" color="#2bb9aa" @click="nextStep">
              NEXT STEP
              <font-awesome-icon class="ml-1" icon="chevron-right" />
            </v-btn>
            <div class="mt-5"></div>
          </v-form>
        </v-card-text>
      </v-card>

      <div class="lang">
        <lang-select></lang-select>
      </div>
    </div>
    <div class="grey-background"></div>
  </div>
</template>

<script>
export default {
  created() {},
  mounted() {
    const params = this.$route.query;
    if (params.request != undefined) {
      this.$store.dispatch("invite_detail", {
          uuid: params.request
        })
        .then(response => {
          this.email = response.data.email;
          this.emailEditDisabled = true; 
        });
    }
  },
  data: () => ({
    fieldRules: [
      v => !!v || "This field is Required",
      v => /^\S*$/.test(v) || "Remove space",
    ],

    emailRule: [
      v => !!v || "Email is required",
      v => /^\S*$/.test(v) || "Remove space",
      v => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || "Invalid e-mail.";
      }
    ],

    passwordRules: [
      v => !!v || "This field is Required",
      v =>
        /(?=.*[a-z])/.test(v) ||
        "Must contain at least 1 lowercase alphabetical character",
      v =>
        /(?=.*[A-Z])/.test(v) ||
        "Must contain at least 1 uppercase alphabetical character",
      v => /(?=.*[0-9])/.test(v) || "Must contain at least 1 numeric character",
      v =>
        /(?=.[!@#\$%\^&])/.test(v) ||
        "Must contain at least one special character",
      v => /(?=.{8,})/.test(v) || "Must be eight characters or longer"
    ],

    phoneRules: [
      v => !!v || "This field is Required",
      v => v.length == 14 || "Incorrect phone number"
    ],

    valid: false,
    loading: false,
    termsAgreed: true,

    username: "",
    email: "",
    emailEditDisabled: false,
    password: "",
    passwordConfirm: "",
    mobileNumber: "",
    acceptPrivacy: false
  }),
  methods: {
    nextStep: function() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (this.password != this.passwordConfirm) {
        this.password = "";
        this.passwordConfirm = "";
        return;
      }

      if (!this.acceptPrivacy) {
        this.termsAgreed = false;
        return;
      }

      this.loading = true;
      this.$store
        .dispatch("register", {
          username: this.username,
          email: this.email,
          password: this.password,
          phone_number: this.mobileNumber
        })
        .then(() => {
          this.loading = false;
          this.$router.push({ path: "/register-verify" });
        })
        .catch(() => {
          this.loading = false;
          this.username = "";
          this.email = "";
          this.password = "";
          this.passwordConfirm = "";
          this.mobileNumber = "";
        });
    }
  }
};
</script>
